<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
    <template v-if="frame">
      <path fill="#fff" d="M21 21.7H3c-.4 0-.8-.3-.8-.8V3.2c0-.4.3-.8.8-.8h18c.4 0 .8.3.8.8v17.6c0 .4-.3.8-.8.9z" />
      <path
        d="M3 22.2c-.3 0-.6-.1-.9-.4-.2-.2-.4-.6-.4-.9V3.2c0-.3.1-.7.4-.9.2-.3.5-.4.9-.4h18c.3 0 .7.1.9.4.2.2.4.6.4.9v17.6c0 .3-.1.6-.3.9-.2.3-.5.4-.9.5H3zm18-1v.5-.5c.1 0 .2-.1.2-.1.1-.1.1-.1.1-.2V3.2c0-.1 0-.2-.1-.2-.1-.1-.1-.1-.2-.1H3c-.1 0-.2 0-.2.1s-.1.1-.1.2v17.7c0 .1 0 .2.1.2 0 .1.2.1.2.1h18zm0 0v.5-.5z"
      />
      <path
        fill="#47a3cc"
        d="M5.5 10.7c-.7 0-1.3.6-1.3 1.3 0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3zm0-5c-.7 0-1.3.6-1.3 1.3s.6 1.3 1.3 1.3S6.8 7.7 6.8 7c0-.7-.6-1.3-1.3-1.3zm0 10.1c-.7 0-1.3.6-1.3 1.3s.6 1.3 1.3 1.3 1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3zM8 17.9h11.8v-1.7H8v1.7zm0-5.1h11.8v-1.7H8v1.7zm0-6.7v1.7h11.8V6.1H8z"
      />
    </template>
    <path
      v-else
      d="M4,10.5a1.5,1.5,0,0,0,0,3,1.5,1.5,0,0,0,0-3Zm0-6A1.538,1.538,0,0,0,2.5,6,1.538,1.538,0,0,0,4,7.5,1.538,1.538,0,0,0,5.5,6,1.538,1.538,0,0,0,4,4.5Zm0,12a1.5,1.5,0,0,0,0,3,1.5,1.5,0,0,0,0-3ZM7,19H21V17H7Zm0-6H21V11H7ZM7,5V7H21V5Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'ListIcon',
  props: {
    frame: { type: Boolean, default: true },
  },
}
</script>
